import { faComputer } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Pako from "pako";
import { useAppDispatch, useAppSelector } from "../../../../../app/hooks";
import { seedAll } from "../../../../../common/generateUniqueId";
import SaveFormat from "../../../../../common/save/SaveFormat";
import { OneDrivePicker } from "../../../../editor/components/oneDrive/OneDrivePicker";
import { loadEditorState, resetEditor } from "../../../../editor/editorSlice";
import {
	fetchLogicsConfiguration,
	resetLogics,
} from "../../../../logics/logicsSlice";
import { resetMenuManager } from "../../../../menuManager/menuManagerSlice";
import {
	closeWindow,
	resetWindowManager,
	WindowTypeAndPropsDefinition,
} from "../../../windowManagerSlice";
import css from "./LoadProjectWindow.module.css";

export interface LoadProjectWindowProps {}

export type LoadProjectWindowTypeAndProps = WindowTypeAndPropsDefinition<
	"loadProject",
	LoadProjectWindowProps
>;

export function LoadProjectWindow(
	props: LoadProjectWindowProps & { id: string },
) {
	const dispatch = useAppDispatch();
	const isDevModeActive = useAppSelector((state) => state.system.devMode);

	function loadProject(cb: (saveFormat: SaveFormat) => void) {
		const input = document.createElement("input");
		input.type = "file";
		input.accept = ".ppf";

		input.onchange = (event) => {
			const file = (event.target as HTMLInputElement).files?.[0];

			if (!file) {
				console.warn(`Error reading file.`);
				return;
			}

			const reader = new FileReader();
			reader.readAsArrayBuffer(file);

			reader.onload = (event) => {
				const content = event.target?.result;

				if (!content) {
					console.warn(`Error reading file contents.`);
					return;
				}

				if (typeof content === "string") {
					console.warn(`File content read as string.`);
					return;
				}

				const json = Pako.inflate(new Uint8Array(content), { to: "string" });
				const saveFormat = JSON.parse(json) as SaveFormat;
				saveFormat.editor.blockPreview = null;
				console.log({ saveFormat });

				cb(saveFormat);
			};
		};

		input.click();
	}

	return (
		<div className={css.content}>
			<div id="loadproject" className={css.content}>
				<div className={css.confirmButtonChunk}>
					<button
						className={css.confirmButton}
						onClick={() => {
							loadProject((saveFormat) => {
								dispatch(resetEditor());
								dispatch(resetWindowManager());
								dispatch(resetMenuManager());
								dispatch(resetLogics());
								dispatch(
									fetchLogicsConfiguration({
										...saveFormat.logicsCommitRef,
										migrate: false,
									}),
								);

								dispatch(loadEditorState(saveFormat.editor));
								seedAll(saveFormat.idMap);

								dispatch(closeWindow(props.id));
							});
						}}
					>
						<FontAwesomeIcon icon={faComputer} /> Computer
					</button>
					<OneDrivePicker
						modalId={props.id}
						type="modal"
						disabled={false}
						newName={null}
					/>
				</div>
			</div>
		</div>
	);
}
